<template>
  <section
    :class="['full-width-cross-promo full-width-cross-promo--right u-padd-btm u-padd-top', displayModel.backgroundColorCss]">
    <div class="max-width-xxl u-mrg-center wrapper--sm">
      <!--Main grid-->
      <div class="grid">
        <!--left side-->
        <div class="grid-item image grid-item-w100 grid-item-w50@lg">
          <h2 class="h h-xl h-xl-alt">{{ displayModel.header }}</h2>
          <p>{{ displayModel.subHeader }}</p>
          <a :href="displayModel.ctaDestination" class="link-cta u-color-black">{{ displayModel.ctaLabel }}</a>
        </div>
        <!--right side-->
        <div class="grid-item image grid-item-w100 grid-item-w50@lg">
          <ContentCarousel :slides="displayModel.slides" :playOnSlide="playOnSlide" :sliderSettings="sliderSettings" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, reactive, watch, onUnmounted } from 'vue';
import ContentCarousel from './components/ContentCarousel.vue';

const sliderSettings = reactive({
  widthDetection: 'manual',
  arrows: true,
  adaptiveHeight: true,
  focuseOnSelect: true,
  centerMode: false,
  unslick: false,
  infinite: false,
  dots: true,
});

const props = defineProps({
  displayModel: {
    type: Object,
    default: () => ({
      header: 'Header',
      subHeader: 'Subheader',
      slides: []
    })
  },
  playOnSlide: {
    type: Boolean,
    default: false
  }
});


</script>

<style scoped>

</style>